import {Injectable} from '@angular/core';
import {z} from 'zod';

export const addressSchema = z.object({
    name: z.string().nullable(),
    address1: z.string().nullable(),
    address2: z.string().nullable(),
    city: z.string().nullable(),
    postalCode: z.string().nullable(),
    countryCode: z.string().nullable(),
});

export type Address = z.infer<typeof addressSchema>;

@Injectable({
    providedIn: 'root',
})
export class AddressAdapter {
    toApiModel(item: Address): any {
        return {
            name: item.name,
            address1: item.address1,
            address2: item.address2,
            city: item.city,
            postalCode: item.postalCode,
            countryCode: item.countryCode,
        };
    }
}
